module.exports = __webpack_public_path__ + "static/media/tab-img-2.5adf94d8.jpg";